import React from 'react';
import { Checkbox } from '@mui/material';
import PropTypes from 'prop-types';
import { useFieldArray, useFormContext } from 'react-hook-form';

export const CheckOptionInput = ({ name, options, ...props }) => {
    const { control } = useFormContext();
    const { fields, remove, append } = useFieldArray({ control, name });

    return options.map(option => (
        <CheckOption key={option.value} option={option} remove={remove} append={append} fields={fields} {...props} />
    ));
};

const CheckOption = ({ className = '', option, ...rest }) => {
    const value = rest.fields.some(({ value }) => value === option.value);

    const handleChange = e => {
        if (e.target.checked) {
            if (option && !rest.fields.some(({ value }) => value === option.value)) {
                rest.append(option);
            }
        } else {
            const index = rest.fields.findIndex(({ value }) => value === option.value);
            rest.remove(index);
        }
    };

    return (
        <label htmlFor={option.value} className={`tw-cursor-pointer tw-block ${className}`}>
            <div className='tw-font-normal tw-flex tw-items-center tw-ml-[-10px]'>
                <Checkbox
                    id={option.value}
                    size='large'
                    checked={value}
                    onChange={handleChange}
                    className='tw-border-2 tw-border-primary-500 tw-text-primary-500 checked:tw-border-primary tw-mt-[-5px]'
                />
                <span>{option.label}</span>
            </div>
            <div className='tw-pl-[30px] tw-mt-[-5px] tw-text-[12px] tw-text-[#5A5A5A] tw-font-light'>
                {option.description}
            </div>
        </label>
    );
};

// -------- PropTypes -------- //

CheckOptionInput.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired,
            description: PropTypes.string
        })
    ).isRequired
};

CheckOption.propTypes = {
    className: PropTypes.string,
    option: PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
        description: PropTypes.string
    }).isRequired,
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired
        })
    ).isRequired,
    append: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired
};
